import { Record } from 'immutable';
import { actionTypes } from './forgot-password.actions';
import { actionTypes as loginActionTypes } from '../../login/login.actions';
import { Err } from '../../err';

export const ForgotPasswordState = Record({
  isSaving: false,
  err: null
});

export const forgotPasswordReducer = (state = new ForgotPasswordState(), action) => {
  switch (action.type) {
    case actionTypes.CREATE_PASSWORD_RESET_BEGIN:
      return state.set('err', null)
                  .set('isSaving', true);
    case actionTypes.CREATE_PASSWORD_RESET_SUCCESS:
      return state.set('isSaving', false);
    case actionTypes.CREATE_PASSWORD_RESET_FAILURE:
      return state.set('err', new Err(action.err))
                  .set('isSaving', false);
    case loginActionTypes.CREATE_NEW_SESSION_BEGIN:
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/acct/password/forgot-password.reducer.js